<template>
  <div :style="tamanho ? `width: ${tamanho}px; height: ${tamanho}px;` : ''" :class="['bloco-wrapper', `${classe}-bloco`]">
    <div :class="['bloco', { animacao: ciclo == 1 }]"></div>
    <div :class="['bloco', { animacao: ciclo == 2 }]"></div>
    <div :class="['bloco', { animacao: ciclo == 4 }]"></div>
    <div :class="['bloco', { animacao: ciclo == 3 }]"></div>
  </div>
</template>

<script>
export default {
  name: "Bloco",
  props: {
    tamanho: String,
    classe: String
  },
  data() {
    return {
      ciclo: 1
    };
  },
  mounted() {
    this.cicloAnimacao();
  },
  methods: {
    cicloAnimacao() {
      setTimeout(() => {
        if (this.ciclo == 4) {
          this.ciclo = 0;
        }
        this.ciclo += 1;
        this.cicloAnimacao();
      }, 400);
    }
  }
};
</script>
<style lang="scss" scoped>
@keyframes blocoAnimacao {
  0% {
    transform: scale(1);
    filter: brightness(1);
  }
  50% {
    transform: scale(1.1);
    filter: brightness(1.2);
  }
  100% {
    transform: scale(1);
    filter: brightness(1);
  }
}
.bloco-wrapper {
  width: 100px;
  height: 100px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6%;
}
.bloco {
  border-radius: 5%;
  width: 100%;
  height: 100%;
  background: var(--cinza02);
}
.animacao {
  animation: blocoAnimacao 0.5s infinite ease-in-out;
}
.preferencia_tarifaria-bloco,
.class_importacao-bloco {
  .bloco {
    background: var(--importacao);
  }
}

.pis_cofins-bloco,
.cide_combustivel-bloco {
  .bloco {
    background: var(--pis-cofins);
  }
}

.icms_interno-bloco,
.icms_st-bloco,
.carga_liquida-bloco,
.antecipacao-bloco,
.difal-bloco {
  .bloco {
    background: var(--icms);
  }
}

.ipi-bloco {
  .bloco {
    background: var(--ipi);
  }
}
.azul-bloco {
  .bloco {
    background: var(--azul2);
  }
}
.verde-bloco {
  .bloco {
    background: var(--verde2);
  }
}
</style>
